<div class="content-heading">
  <div class="header-container">
    <h3>Detalle de Moneda</h3>
    <small>Configuración de divisas para el sistema</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default">
    <div class="card-body">
      <form #Form="ngForm" (ngSubmit)="formSubmit()">
        
        <div class="row">
          <div class="col-md-4">
            <aph-custom-text 
              label="Código" 
              placeholder="Ej. MXN" 
              [(ngModel)]="currency.currencyCode" 
              name="currencyCode" 
              [required]="true" 
              [maxLength]="3" 
              [disabled]="!isNew"
              style="border:none;">
            </aph-custom-text>
            <small class="text-muted" *ngIf="isNew">Máximo 3 caracteres (ISO)</small>
          </div>

          <div class="col-md-8">
            <aph-custom-text 
              label="Descripción" 
              placeholder="Nombre de la moneda" 
              [(ngModel)]="currency.currencyName" 
              name="currencyName" 
              [required]="true" 
              [maxLength]="50"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <hr class="mt-4">

        <div class="row mt-3">
          <div class="col-12 d-flex">
            <aph-custom-buttons 
              preset="save" 
              label="Guardar" 
              type="submit" 
              [disabled]="!Form.valid"
              class="mr-2">
            </aph-custom-buttons>

            <aph-custom-buttons 
              preset="exit" 
              label="Volver" 
              (btnClick)="btnCancelOnClick()">
            </aph-custom-buttons>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>